export type EncryptedPayload = { iv: string; ct: string };

function b64ToArrayBuffer(b64: string): ArrayBuffer {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes.buffer;
}

function arrayBufferToB64(buf: ArrayBuffer): string {
    const bytes = new Uint8Array(buf);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}

export async function decryptAesGcmB64(payload: EncryptedPayload, keyB64: string): Promise<string> {
    const td = new TextDecoder();
    const cryptoKey = await crypto.subtle.importKey(
        "raw",
        b64ToArrayBuffer(keyB64),
        { name: "AES-GCM" },
        false,
        ["decrypt"]
    );
    const iv = new Uint8Array(b64ToArrayBuffer(payload.iv));
    const ct = b64ToArrayBuffer(payload.ct);
    const plainBuf = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv },
        cryptoKey,
        ct
    );
    return td.decode(plainBuf);
}

export async function encryptAesGcmB64(plain: string, keyB64: string): Promise<EncryptedPayload> {
    const te = new TextEncoder();
    const key = await crypto.subtle.importKey(
        "raw",
        b64ToArrayBuffer(keyB64),
        { name: "AES-GCM" },
        false,
        ["encrypt"]
    );
    const ivBytes = new Uint8Array(12);
    crypto.getRandomValues(ivBytes);
    const cipherBuf = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv: ivBytes },
        key,
        te.encode(plain)
    );
    return {
        iv: arrayBufferToB64(ivBytes.buffer),
        ct: arrayBufferToB64(cipherBuf)
    };
}

export async function encryptJsonAesGcmB64(data: unknown, keyB64: string): Promise<EncryptedPayload> {
    return encryptAesGcmB64(JSON.stringify(data), keyB64);
}


